import Chat from './Chat.svelte';
import TokenManager from './TokenManager.svelte';
import Demo from './Demo.svelte';

window.Chat = function (options) {
    return new Chat(options);
};

window.TokenManager = function (options) {
    return new TokenManager(options);
};

window.Demo = function (options) {
    return new Demo(options);
}